import { graphql } from '@/gql'

export const SkillsQuery = graphql(/* GraphQL */ `
  query Skills($search: String, $skillableType: [SkillableType!], $page: Int) {
    skills(search: $search, skillableType: $skillableType, page: $page) {
      paginatorInfo {
        currentPage
        hasMorePages
      }
      data {
        ... on Skill {
          id
          name
        }
      }
    }
  }
`)

export const IndustriesQuery = graphql(/* GraphQL */ `
  query Industries($page: Int, $first: Int) {
    industries(page: $page, first: $first) {
      paginatorInfo {
        currentPage
        hasMorePages
      }
      data {
        ... on Industry {
          id
          name
        }
      }
    }
  }
`)
